import { render } from "./TeamPageCrumbHeader.vue?vue&type=template&id=43bc7095"
import script from "./TeamPageCrumbHeader.vue?vue&type=script&lang=js"
export * from "./TeamPageCrumbHeader.vue?vue&type=script&lang=js"
script.render = render

export default script